/**
 * Legacy Link in Bio / classic Analytics RPCs filter by pathname `/{username}`.
 * Writers must use this (not `/website/...` or other SPA paths) or clicks vanish.
 */
export function legacyLibAnalyticsPathname(username: string): string {
  const slug = String(username || "")
    .trim()
    .toLowerCase()
    .replace(/^\/+|\/+$/g, "");
  return slug ? `/${slug}` : "/";
}

/**
 * True when a public website path is the Link in Bio surface (including
 * in-page search under `/link-in-bio`). Used so LiB feed clicks still mirror
 * into classic `analytics` even when attributed `page_key` is `"search"`.
 */
export function isLegacyLibMirrorPath(pathname?: string): boolean {
  const p = String(pathname || "").toLowerCase();
  if (!p) return false;
  // /website/:user/link-in-bio… or /:user/link-in-bio…
  return /(?:^|\/)link-in-bio(?:\/|$)/.test(p);
}

/** Mirror classic LiB analytics when attributed or path is the LiB surface. */
export function shouldMirrorLegacyLibAnalytics(
  pathname?: string,
  attributedPageKey?: string,
): boolean {
  return (
    attributedPageKey === "linkInBio" || isLegacyLibMirrorPath(pathname)
  );
}
